const fetchData = async (url) => {
  try {
    const resolved = await fetch(url);
    const data = await resolved.json();
    return data
  } catch(err) {
    console.error(err)
  }
}

const fetchJsonData = async (url) => {
  try {
    const resolved = await fetch(url)
    const data = await resolved.json()
    return data
  } catch(err) {
    console.error(err)
  }
}

const defaultLocationId = () => {
  if (localStorage.getItem('default_location_id') === null) {
    fetchData('/apps/popshoesinventories/default_location.json').then(data => {
      localStorage.setItem('default_location_id', data.primary_location_id);
    });
  }

  return localStorage.getItem('default_location_id')
}

const preferredLocationId = () => localStorage.getItem('preferred_location_id')
const preferredLocationSearchableOnly = () => localStorage.getItem('preferred_location_searchable_only')

const addressFormCoords = () => {
  const key = "address_form_coordinates"
  if (localStorage.getItem(key)) return JSON.parse(localStorage.getItem(key))
}

const locationDetails = async (locationId) => {
  const key = `location_${locationId}_details`
  if (localStorage.getItem(key) === null) {
    if(preferredLocationSearchableOnly() === true || preferredLocationSearchableOnly() === 'true'){
      await fetchData(`/apps/popshoesinventories/searchable_only_locations/${locationId}.json`).then(location => {
        localStorage.setItem(key, JSON.stringify({
          'city': location.city,
          'zip': location.zip,
          'name': location.name
        }));
        
      });

      return JSON.parse(localStorage.getItem(key))
    }
    else{
      await fetchData(`/apps/popshoesinventories/locations/${locationId}.json`).then(location => {
        localStorage.setItem(key, JSON.stringify({
          'city': location.city,
          'zip': location.zip,
          'name': location.name
        }));
      });

      return JSON.parse(localStorage.getItem(key))
    }
  } else {
    return JSON.parse(localStorage.getItem(key))
  }
}

async function fetchLocations() {
  let url = '/apps/popshoesinventories/locations.json';

  if (addressFormCoords()) {
    url = `${url}?lat=${addressFormCoords().latitude}&lon=${addressFormCoords().longitude}`
  } else if (currentCoords()) {
    url = `${url}?lat=${currentCoords().latitude}&lon=${currentCoords().longitude}`
  }

  
  const response = await fetch(url)
  const data = await response.json()
  return data
}

async function fetchSearchableOnlyLocation(id) {
  let url = `/apps/popshoesinventories/searchable_only_locations/${id}.json`;
  const response = await fetch(url)
  const data = await response.json()
  return data
}

async function fetchLocation(id) {
  const url = `/apps/popshoesinventories/locations/${id}.json`
  const response = await fetch(url)
  const data = await response.json()
  return data
}
